import ListTile from "@component/dashboard/credit-score/list_tile";
import { PageRegistration } from "@component/flows/hooks/usePageFlow";
import PageLayout from "@layout/component/page_layout";
import { getKikoffCreditAccountMentalModelName } from "@src/constants";

import styles from "./interstitial.module.scss";

interface InterstitialPageProps extends PageRegistration {}

export default function InterstitialPage({
  configFlow,
  Button,
  page,
}: InterstitialPageProps) {
  configFlow.button(<Button>Continue</Button>);

  return (
    <PageLayout
      className={styles["interstitial"]}
      title={
        <>
          You are financing your Credit Service{" "}
          <span className={styles["em"]}>on credit</span> using the{" "}
          {getKikoffCreditAccountMentalModelName()}, which is a Kikoff-only
          store credit card
        </>
      }
      onBack={() => {
        page.controller.prev();
      }}
    >
      <div className={styles.items}>
        <ListTile
          allowWrap
          leading=""
          title="Start building credit history"
          subtitle="Since your Credit Service is purchased on credit you’ll start building history this month"
        />
        <ListTile
          allowWrap
          leading=""
          title="Access to financial tools & services"
          subtitle="Gain access to services to support your credit journey"
        />
        <ListTile
          allowWrap
          leading=""
          title="Work with real human credit experts"
          subtitle="Work with our awesome team members to accomplish your credit goals"
        />
        <ListTile
          allowWrap
          leading=""
          title="Analyze your credit scores and reports"
          subtitle="See the raw data that lenders and banks use to determine your credit worthiness"
        />
        <ListTile
          allowWrap
          leading=""
          title="Identify incorrect items on your report"
          subtitle="(Coming soon!) Help identify and fax factually incorrect items on your report"
        />
        <ListTile
          allowWrap
          leading=""
          title="Build credit at all 3 credit bureaus"
          subtitle="Open additional products with Kikoff at no additional fee to report to all 3 bureaus"
        />
      </div>
    </PageLayout>
  );
}
